import { ModelSagres } from "../../model-sagres"
import { TipoEvento } from "./tipo-evento"
import { ArquivoEvento } from "./arquivo-evento"

export class Evento extends ModelSagres {
    IdEvento: number
    IdUnidGestora: number
    IdTipoEvento: number | null
    TipoEvento: TipoEvento | undefined
    DeTitulo: string
    DeDescricao: string
    DtInicio: Date | null 
    DtFim: Date | null
    DtCadastro: Date
    DtUltimaAlteracao: Date
    NmUsuarioCadastro: string
    NmUsuarioUltimaAlteracao: string
    VlGastoTotal: number
    ArquivoEvento: ArquivoEvento[] = []
    IdProgramacao?: number | null

    tratarDadosDaAPI(): void {
        if (this.DtInicio) {
            this.DtInicio = new Date(this.DtInicio)
        }
        if (this.DtFim) {
            this.DtFim = new Date(this.DtFim)
        }
        if (this.DtCadastro) {
            this.DtCadastro = new Date(this.DtCadastro)
        }
        if (this.DtUltimaAlteracao) {
            this.DtUltimaAlteracao = new Date(this.DtUltimaAlteracao)
        }
    }
}